import styled from '@emotion/styled';
import { useFormik } from 'formik';
import { Container, GridItem } from './Layout';
import { Modal } from './Modal';
import { ModalButton } from './ModalLayout';
import {
  InputContainer,
  InputFirst,
  RequiredLabel,
} from './PageLayout';
import { TextArea } from './TextArea';
import { TextField } from './TextField';
import { Text } from './Typography';
import * as Yup from 'yup';
import { formErrorMessages } from 'api/resources/responseMessages/formErrors';
import { useTheme } from '@emotion/react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  guidance: string | null;
  onSubmit?: () => void;
}

export const AddConnectionActionPopup = ({
  title,
  isOpen,
  onClose,
  guidance,
 onSubmit,
}: Props) => {
  const theme = useTheme();
  const {
    errors,
    touched,
    resetForm,
    handleChange,
    handleSubmit,
  } = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    initialValues: {

    },

    onSubmit: () => {
      onSubmit?.(
    );
      onClose();
    },
  });

  useEffect(() => {
    resetForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} title={title} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <MainModalContainer direction="column">
          <GridItem>
            {guidance && (
              <Text fontSize="m" fontWeight="normal" className="text">
                {guidance}
              </Text>
            )}
          </GridItem>
          <Container direction="row" justify="space-around">
            <GridItem>
              <CustomModalButton onClick={onClose}>
                <CloseIcon className="icon" /> Cancel
              </CustomModalButton>
            </GridItem>
            <GridItem>
              <CustomModalButton type="submit">
                <CheckIcon className="icon" /> Save Changes
              </CustomModalButton>
            </GridItem>
          </Container>
        </MainModalContainer>
      </form>
    </Modal>
  );
};

export const MainModalContainer = styled(Container)`
  width: 100%;
  height: 100%;
  & .secondary-text {
    margin-bottom: ${({ theme }) => theme.margin.xs};
  }
  & .text {
    margin-bottom: ${({ theme }) => theme.margin.m};
  }
  & .input-title {
    margin-bottom: ${({ theme }) => theme.margin.s};
  }
  & .input-container {
    margin-bottom: ${({ theme }) => theme.margin.l};
  }
  & .icon {
    margin-right: 10px;
  }
`;

const TextInput = styled(TextField)`
  width: 260px;

  .MuiInputBase-root {
    color: ${({ theme }) => theme.palette.primary.main};
  }
  .MuiOutlinedInput-input {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    margin-top: 12px;
    width: 100%;
    overflow: hidden;
  }
`;

const CustomTextArea = styled(TextArea)`
  width: 100%;
  min-height: 120px;
`;

const CustomModalButton = styled(ModalButton)`
  min-width: 200px;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    width: 100%;
    margin-top: 10px;
  }
`;
